import React from 'react';
import styled from 'styled-components';

import { Flex } from '@ui-library/flex';
import { Card } from '@ui-library/card';
import { XLargeText } from '@ui-library/typography';

const WrapSection = styled(Flex)<{ $childrenMinWidth: number }>`
  gap: 1rem;
  flex-wrap: wrap;

  > * {
    flex: 1;
    min-width: ${({ $childrenMinWidth }) => $childrenMinWidth}px;
  }
`;

export const ConfigurationSettingRow = styled(WrapSection).attrs({ $childrenMinWidth: 400 })``;

export const ConfigurationSettingCard: React.FC<{
  cardTitle: string;
  children: React.ReactNode;
}> = ({ cardTitle, children }) => (
  <Card>
    <WrapSection $childrenMinWidth={300} className="fit-height">
      <XLargeText strong>{cardTitle}</XLargeText>

      <Flex flexDirection="column" gap="1rem">
        {children}
      </Flex>
    </WrapSection>
  </Card>
);
